import React from 'react';

const OnboardingPageConfig = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: false,
				},
			},
		},
	},
	routes: [
		{
			path: '/onboarding',
			exact: true,
			component: React.lazy(() => import('./OnboardingPage')),
		},
	],
};

export default OnboardingPageConfig;
